<template>
  <div class="d-flex gap-2">
    <material-image v-bind="$props" />
    <div class="text-left text--darken-2 grey--text">
      <div class="text-body-2 font-weight-regular">SKU {{ code }}</div>
      <div class="text-body-2 font-weight-bold">
        {{ name }}
      </div>
      <slot />
    </div>
  </div>
</template>
<script>
  import MaterialImage from './MaterialImage.vue';

  export default {
    name: 'MaterialThumbnail',

    components: { MaterialImage },

    props: {
      code: {
        type: [String, Number],
        required: true,
      },
      name: {
        type: String,
        default: null,
      },

      size: {
        type: String,
        default: '75px',
      },

      xs: Boolean,
      sm: Boolean,
      md: Boolean,
      lg: Boolean,
    },
  };
</script>
